// Matches the legacy `Em` atom. Centered empty-state message.

export function Empty({ text }: { text: string }) {
  return (
    <div className="py-[60px] px-5 text-center text-dim font-mono text-[13px]">
      {text}
    </div>
  );
}
